import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';

import { GenericdatasetSettings } from '../genericdataset/genericdataset.settings';

@Injectable()
export class ReportService {
  public reportElements: any[] = new Array<any>();
  public deletedReportElements: any[] = new Array<any>();
  public reportsUrl: string = GenericdatasetSettings.api_endpoint + 'reports';
  public reportTypesUrl: string = GenericdatasetSettings.api_endpoint + 'reporttypes';
  public reportCategoriesUrl: string = GenericdatasetSettings.api_endpoint + 'reportcategories';
  public reportElementsUrl: string = GenericdatasetSettings.api_endpoint + 'reportelements';
  public reportTypeElementsUrl: string = GenericdatasetSettings.api_endpoint + 'reporttypeelements';
  public reportElementTypesUrl: string = GenericdatasetSettings.api_endpoint + 'reportelementtypes';
  public reportElementSizesUrl: string = GenericdatasetSettings.api_endpoint + 'reportelementsizes';
  public filetransportHaveReportUrl: string = GenericdatasetSettings.api_endpoint + 'filetransporthavereports';
  public invoiceHaveReportUrl: string = GenericdatasetSettings.api_endpoint + 'invoicehavereports';
  public tiersHaveReportUrl: string = GenericdatasetSettings.api_endpoint + 'tiershavereports';
  public scalesUrl: string = GenericdatasetSettings.api_endpoint + 'reportscales';
  public marginsUrl: string = GenericdatasetSettings.api_endpoint + 'reportmargins';
  public sizesUrl: string = GenericdatasetSettings.api_endpoint + 'reportsizes';
  public orientationsUrl: string = GenericdatasetSettings.api_endpoint + 'reportorientations';
  public textAlignsUrl: string = GenericdatasetSettings.api_endpoint + 'textaligns';
  public fontFamiliesUrl: string = GenericdatasetSettings.api_endpoint + 'fontfamilies';
  public fontSizesUrl: string = GenericdatasetSettings.api_endpoint + 'fontsizes';
  public colorsUrl: string = GenericdatasetSettings.api_endpoint + 'colors';
  public pdfUrl: string = 'http://pdf.odusseuserp.org/';
  public ftpUrl: string = 'http://ftp.odusseuserp.org/';
  public headers = new Headers({ 'Content-Type': 'application/json' });
  public options = new RequestOptions({ headers: this.headers });

  constructor(public http: Http) {
  }

  public getScales(): Observable<any> {
    const scalesUrl = this.scalesUrl + '?filter[order]=factor&filter[where][id][gte]=1000';
    return this.http.get(scalesUrl, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  public getMargins(): Observable<any> {
    const marginsUrl = this.marginsUrl;
    return this.http.get(marginsUrl, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  public getSizes(): Observable<any> {
    const sizesUrl = this.sizesUrl;
    return this.http.get(sizesUrl, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  public getOrientations(): Observable<any> {
    const orientationsUrl = this.orientationsUrl;
    return this.http.get(orientationsUrl, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  public getReportElementTypes(): Observable<any> {
    const reportElementTypesUrl = this.reportElementTypesUrl;
    return this.http.get(reportElementTypesUrl, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  public getReportElementSizes(): Observable<any> {
    const reportElementSizesUrl = this.reportElementSizesUrl;
    return this.http.get(reportElementSizesUrl, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  public getReportTypeElements(id: number): Observable<Element[]> {
    const reportTypeElementsUrl = this.reportTypesUrl + '/' + id + '/elements?filter={"order":"index","where":{"elementp_id":111},"include":{"relation":"elements","scope":{"include":{"relation":"elements"}}}}';
    return this.http.get(reportTypeElementsUrl, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  public getReportType(id: number): Observable<any> {
    const reportTypeUrl = this.reportTypesUrl + '/' + id;
    return this.http.get(reportTypeUrl, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  public getReportTypesFromCategory(reportcategory_id: number): Observable<any> {
    const reportTypeUrl = this.reportTypesUrl + '?filter[where][reportcategory_id]=' + reportcategory_id;
    return this.http.get(reportTypeUrl, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  public getReportElements(id: number): Observable<any> {
    const reportElementsUrl = this.reportsUrl + '/' + id + '/elements?filter={"order":"index","where":{"elementp_id":111},"include":{"relation":"elements","scope":{"include":{"relation":"elements"}}}}';
    return this.http.get(reportElementsUrl, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  public getElementValue(field: string, id: number): Observable<any> {
    const path: string[] = field.split('.');
    let elementUrl = GenericdatasetSettings.api_endpoint + path[0] + '/' + id;
    for (let i = 1; i < path.length - 1; i++) {
      elementUrl = elementUrl + '/' + path[i];
    }
    return this.http.get(elementUrl, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  public addReportTypeElement(item: any): Observable<any> {
    const body = JSON.stringify(item);
    return this.http.post(this.reportTypeElementsUrl, body, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  public addReportElement(item: any): Observable<any> {
    const body = JSON.stringify(item);
    return this.http.post(this.reportElementsUrl, body, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  public addFiletransportHaveReport(filetransport_id: number, report_id: number): Observable<any> {
    const body = JSON.stringify({ filetransport_id, report_id });
    return this.http.post(this.filetransportHaveReportUrl, body, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  public addInvoiceHaveReport(invoice_id: number, report_id: number): Observable<any> {
    const body = JSON.stringify({ invoice_id, report_id });
    return this.http.post(this.invoiceHaveReportUrl, body, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  public addTiersHaveReport(tiers_id: number, report_id: number): Observable<any> {
    const body = JSON.stringify({ tiers_id, report_id });
    return this.http.post(this.tiersHaveReportUrl, body, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  public updateReportTypeElement(item: any): Observable<any> {
    const reportTypeElementsUrl = this.reportTypeElementsUrl + '/' + item.id;
    const body = JSON.stringify(item);
    return this.http.put(reportTypeElementsUrl, body, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  public updateReportTypeElements(reportElements: any[], id: number, elementp_id: number) {
    this.deleteReportTypeElements();
    reportElements.forEach((reportTypeElement) => {
      if (elementp_id >= 1000 && reportTypeElement.elementp_id != elementp_id) {
        reportTypeElement.elementp_id = elementp_id;
      }
      if (reportTypeElement.parent_id >= 1000) {
        this.updateReportTypeElement(reportTypeElement).subscribe((element) => {
          //reportElements[reportTypeElement.index] = element;
          if (reportTypeElement.elements.length > 0) {
            this.updateReportTypeElements(reportTypeElement.elements, id, element.id);
          }
        }, (error) => { console.log(error); });
      } else {
        reportTypeElement.parent_id = id;
        this.addReportTypeElement(reportTypeElement).subscribe((element) => {
          reportElements[reportTypeElement.index].id = element.id;
          if (reportTypeElement.elements.length > 0) {
            this.updateReportTypeElements(reportTypeElement.elements, id, element.id);
          }
        }, (error) => { console.log(error); });
      }
    });
  }
  public deleteReportTypeElement(item: any): Observable<any> {
    const reportTypeElementsUrl = this.reportTypeElementsUrl + '/' + item.id;
    return this.http.delete(reportTypeElementsUrl, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  public deleteReportTypeElements() {
    this.deletedReportElements.forEach((reportTypeElement) => {
      this.deleteReportTypeElement(reportTypeElement).subscribe((res) => { }, (error) => { console.log(error); });
    });
    this.deletedReportElements = new Array<any>();
  }
  public updateReportElement(item: any): Observable<any> {
    const reportElementsUrl = this.reportElementsUrl + '/' + item.id;
    const body = JSON.stringify(item);
    return this.http.put(reportElementsUrl, body, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  public updateReportElements(reportElements: any[], id: number, elementp_id: number): Promise<any> {
    const reportService = this;
    return new Promise(
      function(resolve, reject) {
        const promises: any = [];
        reportService.deleteReportElements();
        reportElements.forEach((reportElement) => {
          if (elementp_id >= 1000 && reportElement.elementp_id != elementp_id) {
            reportElement.elementp_id = elementp_id;
          }
          if (reportElement.parent_id >= 1000) {
            reportService.updateReportElement(reportElement).subscribe((element: any) => {
              //reportElements[reportElement.index] = element;
              if (reportElement.elements && reportElement.elements.length > 0) {
                reportService.updateReportElements(reportElement.elements, id, element.id);
              }
            }, (error: any) => { console.log(error); });
          } else {
            reportElement.parent_id = id;
            reportService.addReportElement(reportElement).subscribe((element: any) => {
              reportElements[reportElement.index].id = element.id;
              if (reportElement.elements && reportElement.elements.length > 0) {
                reportService.updateReportElements(reportElement.elements, id, element.id);
              }
            }, (error: any) => { console.log(error); });
          }
        });
        Promise.all(promises).then((res) => {
          resolve();
        }).catch((err) => {
          reject();
        });
      });
  }
  public deleteReportElement(item: any): Observable<any> {
    const reportElementsUrl = this.reportElementsUrl + '/' + item.id;
    return this.http.delete(reportElementsUrl, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  public deleteReportElements() {
    this.deletedReportElements.forEach((reportTypeElement) => {
      this.deleteReportElement(reportTypeElement).subscribe((res) => { }, (error) => { console.log(error); });
    });
    this.deletedReportElements = new Array<any>();
  }
  public getTextAligns(): Observable<any> {
    const textAlignsUrl = this.textAlignsUrl;
    return this.http.get(textAlignsUrl, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  public getFontFamilies(): Observable<any> {
    const fontFamiliesUrl = this.fontFamiliesUrl + '?filter[order]=name&filter[where][id][gte]=1000';
    return this.http.get(fontFamiliesUrl, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  public getFontSizes(): Observable<any> {
    const fontSizesUrl = this.fontSizesUrl + '?filter[order]=value&filter[where][id][gte]=1000';
    return this.http.get(fontSizesUrl, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  public getColors(): Observable<any> {
    const colorsUrl = this.colorsUrl;
    return this.http.get(colorsUrl, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public extractData(res: Response) {
    const body = res.json();
    return body;
  }

  public handleError(error: any) {
    const errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    return Observable.throw(errMsg);
  }

  public createPDF(id: number): void {
    this.http.get(this.pdfUrl + 'create/' + id).subscribe(
      (res) => { },
      (err) => { console.log(err); }
    );
  }

  public downloadPDF(id: number): void {
    this.http.get(this.ftpUrl + 'download/' + id + '.pdf').subscribe(
      (res) => { this.downloadFile(res); },
      (err) => { console.log(err); }
    );
  }

  private downloadFile(data: Response) {
    const blob = new Blob([data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    window.open(url);
  }

}
